'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uploadFile = exports.UPLOAD_FILE = exports.saveTriple = exports.SAVE_TRIPLE = exports.updateEntity = exports.UPDATE_ENTITY = exports.saveEntity = exports.SAVE_ENTITY = exports.logout = exports.LOGOUT = exports.deleteTriple = exports.DELETE_TRIPLE = exports.deleteEntity = exports.DELETE_ENTITY = exports.auth = exports.AUTH = undefined;

var _nthArg2 = require('lodash/nthArg');

var _nthArg3 = _interopRequireDefault(_nthArg2);

var _identity2 = require('lodash/identity');

var _identity3 = _interopRequireDefault(_identity2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.updateEntityFields = updateEntityFields;

var _capeRedux = require('cape-redux');

var _reduxGraph = require('redux-graph');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AUTH = exports.AUTH = 'fire/AUTH';
var auth = exports.auth = (0, _capeRedux.noopAction)(AUTH);

// @TODO Switch to using cape-graph actions for entities and triples.

var DELETE_ENTITY = exports.DELETE_ENTITY = 'fire/DELETE_ENTITY';
var deleteEntity = exports.deleteEntity = (0, _capeRedux.createSimpleAction)(DELETE_ENTITY, _reduxGraph.requireIdType, (0, _nthArg3.default)(1));

var DELETE_TRIPLE = exports.DELETE_TRIPLE = 'fire/DELETE_TRIPLE';
var deleteTriple = exports.deleteTriple = (0, _capeRedux.createSimpleAction)(DELETE_TRIPLE, _identity3.default, (0, _nthArg3.default)(1));

var LOGOUT = exports.LOGOUT = 'fire/LOGOUT';
var logout = exports.logout = (0, _capeRedux.noopAction)(LOGOUT);

var SAVE_ENTITY = exports.SAVE_ENTITY = 'fire/SAVE_ENTITY';
var saveEntity = exports.saveEntity = (0, _capeRedux.createSimpleAction)(SAVE_ENTITY, _identity3.default, (0, _nthArg3.default)(1));

var UPDATE_ENTITY = exports.UPDATE_ENTITY = 'fire/UPDATE_ENTITY';
var updateEntity = exports.updateEntity = (0, _capeRedux.createSimpleAction)(UPDATE_ENTITY, _identity3.default, (0, _nthArg3.default)(1));
function updateEntityFields(entity, fields) {
  return updateEntity(_extends({}, (0, _reduxGraph.requireIdType)(entity), fields));
}

var SAVE_TRIPLE = exports.SAVE_TRIPLE = 'fire/SAVE_TRIPLE';
var saveTriple = exports.saveTriple = (0, _capeRedux.createSimpleAction)(SAVE_TRIPLE, _reduxGraph.buildTriple, (0, _nthArg3.default)(1));

var UPLOAD_FILE = exports.UPLOAD_FILE = 'fire/UPLOAD_FILE';
var uploadFile = exports.uploadFile = (0, _capeRedux.createAction)(UPLOAD_FILE);


//////////////////
// WEBPACK FOOTER
// ./~/cape-firebase/lib/actions.js
// module id = 206
// module chunks = 0